import { Route } from '@angular/router';
import { AccessoriesComponent } from '@features/shopping/accessories/accessories.component';
import { DeviceDetailsPurchaseComponent } from '@features/shopping/device-details-purchase/device-details-purchase.component';
import { DeviceListComponent } from '@features/shopping/device-list/device-list.component';
import { FinalizeOrderComponent } from '@features/shopping/finalize-order/finalize-order.component';
import { ReviewComponent } from '@features/shopping/review/review.component';

export const device_purchase_routes: Route[] = [
  {
    path: 'device-list',
    component: DeviceListComponent,
    title: 'Select Device',
    data: { order_type_id: 17 }
  },
  {
    path: 'device-details',
    component: DeviceDetailsPurchaseComponent,
    title: 'Customize Device',
    data: { order_type_id: 17 }
  },
  {
    path: 'accessories',
    component: AccessoriesComponent,
    title: 'Get Add Ons',
    data: { order_type_id: 17 }
  },
  {
    path: 'finalize-order',
    component: FinalizeOrderComponent,
    title: 'Finalize Your Order',
    data: { order_type_id: 17 }
  },
  {
    path: 'review/:id',
    component: ReviewComponent,
    title: 'Review Your Order',
    data: { order_type_id: 17 }
  },
  {
    path: '',
    redirectTo: 'device-list',
    pathMatch: 'full'
  }
];
